/* eslint-disable max-len */
import React from 'react';
import {
  Card, Spin, Radio, Button, DatePicker,
} from 'antd';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';

import CenteredContent from '@common/components/ui/CenteredContent';
import useStateBateryChart from './useStateBateryChart';
import styles from './StateBattery.module.less';

function StateBateryChart(props) {

  const { t } = useTranslation();
  const { className } = props;
  const {
    loading, optionsGraph, series, typeGraph,
    handleSelectGraph, selectGraph, constants,
    changeDate, datePicker, setDatePicker,
    setDatePickerWeek, datePickerWeek, infoGraph, messageTotalRegisters, timeRegisters,
    heigthCard,
  } = useStateBateryChart();

  return (
    <Card className={className} style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)', height: { heigthCard } }}>
      <div className={styles.header}>
        {(() => {

          if (selectGraph === constants.HISTOGRAM_CONSULT) {

            return (
              <div className={styles.datepicker_input}>
                <div className={styles.header_datepicker}>

                  <Button className={styles.btnPre} onClick={() => changeDate(-1)} disabled={loading}>{'<'}</Button>

                  <DatePicker className={styles.btnCenter} value={datePicker} format="YYYY-MM-DD" onChange={setDatePicker} disabled={loading} />

                  <Button className={styles.btnNext} onClick={() => changeDate(1)} disabled={loading}>{'>'}</Button>

                </div>
              </div>
            );

          }
          return (
            <>
              <div className={styles.datepicker_input}>

                <DatePicker className={styles.btnCenter} value={datePickerWeek} onChange={setDatePickerWeek} disabled={loading} picker="week" />

              </div>
            </>
          );

        })()}

        <div className={styles.wapperBtn}>
          <Radio.Group value={selectGraph} onChange={handleSelectGraph} className={styles.btnGroup} disabled={loading}>
            <Radio.Button value={constants.BOX_CONSULT}>{t('views.device_graphics.battery_state.boxPlot')}</Radio.Button>
            <Radio.Button value={constants.HISTOGRAM_CONSULT}>{t('views.device_graphics.battery_state.histogram')}</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      {(() => {

        if (loading) {

          return (
            <CenteredContent>
              <Spin tip={t('views.device_graphics.loading_data_graphs')} />
            </CenteredContent>
          );

        }

        return (
          <>
            <ResponsiveContainer width="95%" height={350}>
              <Chart
                className="container-graph-third"
                options={optionsGraph}
                series={series}
                width="100%"
                type={typeGraph}
              />
            </ResponsiveContainer>
            <div>
              <p className={styles.label_info}>{infoGraph}</p>
            </div>
            {(() => {

              if (selectGraph === constants.HISTOGRAM_CONSULT) {

                return (

                  <div>
                    <p className={styles.label_info}>{timeRegisters}</p>
                    <p className={styles.label_info}>{messageTotalRegisters}</p>
                  </div>
                );

              }
              return (
                <>

                </>
              );

            })()}
          </>
        );

      })()}
    </Card>
  );

}

StateBateryChart.propTypes = {
  className: PropTypes.string,
};

StateBateryChart.defaultProps = {
  className: null,
};

export default StateBateryChart;
